/*
 * Lead forms — shared submit for the inline storefront forms (contact, custom-order).
 * Posts JSON to our own ops endpoint (POST /leads) and shows an honest inline
 * success/error state from the real response. NO Shopify /contact, NO native form
 * navigation — that path caused a page reload to ?contact_posted=true even with
 * Shopify spam protection off. A plain <form> + fetch is a single, clean submit.
 *
 * Markup contract — a wrapper carries config, a plain <form> lives inside, the
 * success/error panels are siblings:
 *   <div data-lead-form
 *        data-leads-url="https://…/leads"
 *        data-source="contact|custom_order"
 *        data-turnstile-required="true|false">
 *     <form>
 *       … inputs named: name, email, phone, company, country, message …
 *       … form-specific inputs carry [data-lead-detail] (name = details key) …
 *       <input name="hp_field" …>          honeypot (hidden from humans)
 *       <input name="referral_code" data-lead-ref hidden>  (filled by referral.js)
 *       {% render 'lead-turnstile' %}     (widget + [data-turnstile-hint] notice)
 *       <button data-lead-submit data-label-submit="…" data-label-submitting="…">
 *     </form>
 *     <div data-lead-success hidden>…</div>
 *     <div data-lead-error hidden>… <button data-lead-retry></button></div>
 *   </div>
 *
 * Payload (LeadCreate, see ops/_system/api/app/schemas/leads.py): email (required),
 * name/phone/company/country, source, source_url, message, details {}, referral_code,
 * utm {}, turnstile_token (verified server-side), hp_field (honeypot). The server
 * also rate-limits and dedups (same email+source within a window), so retries are safe.
 */
(function () {
  var wraps = document.querySelectorAll('[data-lead-form]');
  if (!wraps.length) return;

  // Ground truth for "Turnstile satisfied" — shared implementation in
  // assets/lead-submit.js (widget API first, hidden input as fallback). The submit
  // button is never disabled by Turnstile state; the contract is documented there.
  var tokenFor = window.bqLeadToken;

  // Clear the "finish the check" notice on every form that now has a token. Global
  // because the CF callbacks are global; stays correct with multiple forms on a page.
  function syncAll() {
    var fs = document.querySelectorAll('[data-lead-form]');
    for (var i = 0; i < fs.length; i++) {
      if (fs[i].dataset.turnstileRequired !== 'true') continue;
      var form = fs[i].querySelector('form');
      if (form && tokenFor(form)) window.bqLeadHint(form, false);
    }
  }

  // CF Turnstile callbacks (names match the data-* attrs in snippets/lead-turnstile.liquid).
  window.bqLeadTurnstileVerify = syncAll;
  window.bqLeadTurnstileExpired = syncAll;
  window.bqLeadTurnstileError = syncAll;

  for (var w = 0; w < wraps.length; w++) {
    (function (wrap) {
      var form = wrap.querySelector('form');
      if (!form) return;

      var successEl = wrap.querySelector('[data-lead-success]');
      var errorEl = wrap.querySelector('[data-lead-error]');
      var retryBtn = wrap.querySelector('[data-lead-retry]');
      var submitBtn = form.querySelector('[data-lead-submit]');
      var leadsUrl = wrap.dataset.leadsUrl || '/leads';
      var source = wrap.dataset.source || 'other';
      var turnstileRequired = wrap.dataset.turnstileRequired === 'true';

      function showTurnstileHint(on) { window.bqLeadHint(form, on); }
      function setLabel(text) { if (submitBtn && text) submitBtn.textContent = text; }

      function showSuccess() {
        form.hidden = true;
        if (errorEl) errorEl.hidden = true;
        if (successEl) successEl.hidden = false;
        wrap.classList.remove('is-submitting');
        // Lets a host that wraps the form react to the switch — the consultation modal
        // drops its heading and closes itself. Bubbles, so the listener can sit on the
        // dialog rather than on this wrapper.
        try {
          wrap.dispatchEvent(new CustomEvent('bq:lead-success', { bubbles: true, detail: { source: source } }));
        } catch (e) { /* no CustomEvent constructor — the panel is shown either way */ }
      }
      function showError() {
        form.hidden = true;
        if (successEl) successEl.hidden = true;
        if (errorEl) errorEl.hidden = false;
        wrap.classList.remove('is-submitting');
      }
      function resetForRetry() {
        if (errorEl) errorEl.hidden = true;
        if (successEl) successEl.hidden = true;
        form.hidden = false;
        wrap.classList.remove('is-submitting');
        setLabel(submitBtn && submitBtn.dataset.labelSubmit);
        if (submitBtn) submitBtn.disabled = false;
        showTurnstileHint(false);
      }
      if (retryBtn) retryBtn.addEventListener('click', resetForRetry);

      // Native validation (required, type=email) runs BEFORE this event fires —
      // an invalid form never reaches here. We preventDefault so the <form> (which
      // has no action) can't navigate, then POST JSON to our endpoint.
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        // No token yet: say so instead of failing silently. The widget usually just
        // hasn't finished — clicking again once it shows its checkmark goes through.
        if (turnstileRequired && !tokenFor(form)) {
          showTurnstileHint(true);
          return;
        }
        showTurnstileHint(false);

        wrap.classList.add('is-submitting');
        setLabel(submitBtn && submitBtn.dataset.labelSubmitting);
        // Disabled for the duration of the request only (retry re-enables it), so a
        // double click can't send two inquiries. This is not a Turnstile gate.
        if (submitBtn) submitBtn.disabled = true;

        var payload = window.bqBuildLeadPayload(form, source);
        window.bqSubmitLead(leadsUrl, payload).then(function (ok) {
          if (ok) showSuccess(); else showError();
        });
      });
    })(wraps[w]);
  }

  // Clear a shown notice as soon as the widget catches up, without waiting for a
  // callback that may never come. Purely cosmetic now — nothing is gated on it —
  // so it runs for a minute and stops; after that the next submit re-checks anyway.
  syncAll();
  var leadPolls = 0;
  var leadPollId = window.setInterval(function () {
    syncAll();
    if (++leadPolls >= 120) window.clearInterval(leadPollId); // ~60s
  }, 500);
})();
